export default __webpack_public_path__ + "static/media/user.23288e2a.svg";